export const ADDS_DFP_NETWORK_ID = '21807826148';

export type AdUnit =
  | 'web_searchresults_banner_bottom'
  | 'web_between_search_results'
  | 'web_offer_bottom_banner'
  | 'web_offer_sidebar_banner'
  | 'web_searchresults_sidebar'
  | 'web_searchresults_top_banner';

export const AD_SIZE_SMALL = [300, 250];
export const AD_SIZE_LARGE = [800, 250];
export const AD_SIZE_LARGE_NARROW = [728, 90];

export const AD_SIZE_RESPONSIVE_MAPPING = [
  // for desktop and larger
  {
    viewport: [1024, 500],
    sizes: [AD_SIZE_LARGE, AD_SIZE_LARGE_NARROW],
  },
  // for tablet and smaller
  {
    viewport: [768, 500],
    sizes: [AD_SIZE_SMALL],
  },
];
